<main class="orders-page">
  <header class="topbar">
    <div class="topbar-content">
      <a routerLink="/" class="brand">
        <span class="brand-icon">M</span>

        <span class="brand-text">
          <strong>MeuCardápio</strong>
          <small>Seus pedidos em um só lugar</small>
        </span>
      </a>

      <div class="customer-actions">
        <div class="customer-info" *ngIf="customer">
          <span class="customer-avatar">
            {{ getCustomerInitial() }}
          </span>

          <div>
            <small>Bem-vinda</small>
            <strong>{{ customer.name }}</strong>
          </div>
        </div>

        <button
          type="button"
          class="logout-button"
          (click)="logout()"
        >
          Sair
        </button>
      </div>
    </div>
  </header>

  <section class="content">
    <div class="page-heading">
      <div>
        <span class="eyebrow">
          Histórico de compras
        </span>

        <h1>Meus pedidos</h1>

        <p>
          Acompanhe seus pedidos e consulte os detalhes
          das suas compras.
        </p>
      </div>

      <button
        type="button"
        class="menu-button"
        (click)="goToMenu()"
      >
        <span aria-hidden="true">←</span>
        Voltar ao cardápio
      </button>
    </div>

    <div
      *ngIf="loading"
      class="state-card"
    >
      <span class="loader"></span>

      <div>
        <strong>Carregando seus pedidos</strong>
        <p>Aguarde só um momento.</p>
      </div>
    </div>

    <div
      *ngIf="!loading && error"
      class="state-card error-state"
    >
      <span class="state-icon">!</span>

      <div>
        <strong>
          Não foi possível carregar os pedidos
        </strong>

        <p>{{ error }}</p>

        <button
          type="button"
          class="retry-button"
          (click)="loadOrders()"
        >
          Tentar novamente
        </button>
      </div>
    </div>

    <div
      *ngIf="!loading && !error && !orders.length"
      class="empty-state"
    >
      <div class="empty-icon">🛍️</div>

      <h2>
        Você ainda não fez nenhum pedido
      </h2>

      <p>
        Escolha seus produtos favoritos e faça seu
        primeiro pedido.
      </p>

      <button
        type="button"
        class="primary-button"
        (click)="goToMenu()"
      >
        Ver cardápio
      </button>
    </div>

    <div
      *ngIf="!loading && !error && orders.length"
      class="orders-summary"
    >
      <span>
        {{ orders.length }}

        {{
          orders.length === 1
            ? 'pedido encontrado'
            : 'pedidos encontrados'
        }}
      </span>
    </div>

    <section
      *ngIf="!loading && !error && orders.length"
      class="orders-list"
    >
      <article
        class="order-card"
        *ngFor="let order of orders"
      >
        <header class="order-header">
          <div class="order-title">
            <span class="order-number">
              Pedido #{{ order.id }}
            </span>

            <h2>
              {{
                order.restaurant?.name ||
                'Restaurante'
              }}
            </h2>

            <div class="order-date">
              {{
                order.createdAt
                  | date:'dd/MM/yyyy'
              }}

              às

              {{
                order.createdAt
                  | date:'HH:mm'
              }}
            </div>
          </div>

          <span
            class="status"
            [ngClass]="getStatusClass(order.status)"
          >
            <span class="status-dot"></span>

            {{ getStatusLabel(order.status) }}
          </span>
        </header>

        <div class="order-body">
          <div class="order-info">
            <span class="info-label">
              Tipo do pedido
            </span>

            <strong>
              {{
                getDeliveryTypeLabel(
                  order.deliveryType
                )
              }}
            </strong>
          </div>

          <div
            class="order-info"
            *ngIf="order.tableNumber"
          >
            <span class="info-label">
              Mesa
            </span>

            <strong>
              {{ order.tableNumber }}
            </strong>
          </div>

          <div class="items">
            <div
              class="item-row"
              *ngFor="let item of order.items"
            >
              <div class="item-description">
                <span class="item-quantity">
                  {{ item.quantity }}x
                </span>

                <span>
                  {{
                    item.product?.name ||
                    'Produto'
                  }}
                </span>
              </div>

              <strong>
                {{
                  item.total
                    | currency:'BRL':'symbol':'1.2-2'
                }}
              </strong>
            </div>
          </div>
        </div>

        <footer class="order-footer">
          <div class="order-total">
            <span>Total do pedido</span>

            <strong>
              {{
                order.total
                  | currency:'BRL':'symbol':'1.2-2'
              }}
            </strong>
          </div>

          <div class="order-buttons">
            <button
              type="button"
              class="secondary-button"
              (click)="goToRestaurantMenu(order)"
            >
              Ver cardápio
            </button>


  <button
  *ngIf="
    order.status === 'DELIVERED' ||
    order.status === 'CANCELED'
  "
  type="button"
  class="repeat-button"
  (click)="repeatOrder(order)"
>
  <span aria-hidden="true">↻</span>
  Repetir pedido
</button>



            <button
              type="button"
              class="tracking-button"
              *ngIf="order.trackingCode"
              (click)="trackOrder(order)"
            >
              Acompanhar pedido
            </button>
          </div>
        </footer>
      </article>
    </section>
  </section>
</main>